import React, {Dispatch, useEffect, useState} from 'react';
import {
    Formik,
    Form,
    Field,
} from 'formik';
import {CalculatedRainWater, Marker} from "../App";
import DataForm, {DataFormValues} from "../DataForm";

type Props = {
    marker: Marker|undefined,
    setCalculatedRainWater: Dispatch<CalculatedRainWater|null>
    setStep: Dispatch<string>
    formValues: DataFormValues,
    setFormValues: Dispatch<DataFormValues>
}
function DataFormStep({marker, setCalculatedRainWater, setStep, formValues, setFormValues}: Props) {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return <div>
        <DataForm
            marker={marker}
            setCalculatedRainWater={setCalculatedRainWater}
            setStep={setStep}
            formValues={formValues}
            setFormValues={setFormValues}
        />
    </div>
}

export default DataFormStep;